import Enrollment from '@/models/Enrollment';
import ScheduledLessonReport from '@/models/ScheduledLessonReport';
import { hashMap } from '../shared/hashMap';
import { EnrollmentReports } from '@/components/scheduled-lesson-report/StudentReports.hook';

type JoinReportAndEnrollmentProps = {
  enrollments: Enrollment[];
  reports: ScheduledLessonReport[];
};

export default function joinReportAndEnrollment({
  enrollments,
  reports,
}: JoinReportAndEnrollmentProps) {
  const reportsHashMap = hashMap(reports, report => report.student);

  return enrollments.map<EnrollmentReports>(enrollment => ({
    enrollment,
    report: reportsHashMap.get(enrollment.student.id),
  }));
}
